<template>
  <transition name="fade">
    <div class="xvcoursetree">
      <div class="cursusboom" v-if="isvisible">
        <div
          class="label-wrapper"
          @click="toggleChildren"
          v-if="(depth === 0 && rootLevelVisible === true) || depth !== 0"
        >
          <div v-bind:class="labelClasses">
            <i v-if="nodes" class="fa" :class="iconClasses"></i>
            <i :class="icon" aria-hidden="true"></i>
            <span>
              <a :href="urlDetail" class="treeDetailIcon" @click.stop>
                <font-awesome-icon :icon="iconUrl" />
              </a>
              {{ label }}
            </span>
          </div>
        </div>
        <span v-if="showChildren">
          <XVcourseTree
            :isvisible="showChildren"
            v-for="(node, index) in nodes"
            :key="depth+'_'+index"
            :nodes="node.nodes"
            :icon="node.icon"
            :label="node.label"
            :depth="depth + 1"
            :levelID="node.id"
            :url="node.url"
            :rootLevelVisible="rootLevelVisible"
          ></XVcourseTree>
        </span>
      </div>
    </div>
  </transition>
</template>
<script>
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  name: 'XVcourseTree',
  props: {
    nodes: {
      type: Array
    },
    label: {
      type: String
    },
    depth: {
      type: Number
    },
    isvisible: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    rootLevelVisible: {
      type: Boolean,
      default: true
    },
    levelID: {
      type: Number
    }
  },
  data() {
    return {
      showChildren: false
    }
  },
  mounted: function() {
    if (this.depth === 0) {
      this.showChildren = true
    } else {
      this.showChildren = false
    }
  },
  computed: {
    iconClasses() {
      if (this.nodes.length !== 0) {
        return {
          'fa-chevron-down treeIcon': !this.showChildren,
          'fa-chevron-up treeIcon': this.showChildren
        }
      } else {
        return 'fa-chevron-down disabledTreeIcon'
      }
    },
    labelClasses() {
      return { 'has-children': this.nodes }
    },
    urlDetail() {
      return './SPE356_BH_Cursusboomdetail.aspx?sub=' + this.depth + '&sId=' + this.levelID
    },
    iconUrl() {
      return ['fa', 'pencil-alt']
    }
  },
  methods: {
    toggleChildren: function() {
      this.showChildren = !this.showChildren
    }
  }
}
</script>
